import Vue from "vue";
import axios from "axios";
import moment from "moment";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import { DateTime } from "luxon";

const pickerDateFormat = "YYYY-M-D";
const uiDateFormat = "DD/MM/YYYY";

const CustomFieldType = {
  kString: 0,
  kInt: 1,
  kDouble: 2,
  kDate: 3,
  kLookup: 4,
  kLibrary: 5,
  kDateTime: 6,
};

export default {
  name: "CustomFields",
  props: {
    dataObj: {
      type: Object,
      default: {},
    },
    showGroupFilter: {
      type: Boolean,
      default: true,
    },
    showUnits: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    datetime: Datetime,
    DateTime,
  },
  data: function () {
    return {
      allFields: [],
      customFields: [],
      customGroups: [],
      selectedGroup: -1,
      selectedGroupName: " ",
      groupTabs: [],
      lookups: [],
      libraries: [],
      appData: {},
      showDate: { periodDate: false },
      periodDate: {},
      invalidValidationFields: [],
      refNums: [],
    };
  },
  computed: {
    formattedPeriodDate: function () {
      return this.formatDateUI(moment(this.periodDate));
    },
    lookupValuesLength: function () {
      return this.lookups.length;
    },
    groupSelectionLabel: function () {
      if (this.customGroups.length <= 2) return "";
      else if (this.customGroups.length > 2 && this.selectedGroup >= 0)
        return (
          this.$t("customFields.Group") +
          " " +
          (this.selectedGroup + 1) +
          this.$t("customFields.Of") +
          (this.customGroups.length - 1) +
          " " +
          this.$t("customFields.Displayed")
        );
      else return this.$t("customFields.AllGroupsDisplayed");
    },
  },
  created() {
    this.init();
    this.$root.$on("custom_fields_updated", this.init);
  },
  watch: {
    selectedGroup: function (value) {
      this.selectedGroupFunc(value);
    },
  },
  methods: {
    selectedGroupFunc(value) {
      if (typeof value == "string" && value.trim() == "") return;

      if (value == -1) {
        this.selectedGroupName = " ";
        this.customFields = this.allFields;
      } else {
        this.selectedGroupName = this.customGroups.filter(
          (t) => t.id == value
        )[0].name;
        this.customFields = this.allFields.filter(
          (t) => t.groupName == this.selectedGroupName
        );
      }
    },
    hasId(data, id) {
      return data.some(function (el) {
        return el.itemId === id;
      });
    },
    distinctValues(value, index, self) {
      return self.indexOf(value) === index;
    },
    init() {
      /*if (this.$store.state.csAppsOfflineMode) {
        if (this.dataObj) {
          this.allFields = this.dataObj;
          this.customFields = this.dataObj;
        }
      } else {
        if (this.dataObj.items) {
          this.allFields = this.dataObj.items;
          this.customFields = this.dataObj.items;
        }
      }*/

      if (this.dataObj.items) {
        this.allFields = this.dataObj.items;
        this.customFields = this.dataObj.items;

        // this.customFields.forEach((f) => {
        //   if (f.type == 4) {
        //     f["displayObj"] = {};
        //   }
        // });
      }

      var tabs = this.customFields
        .map((a) => a.groupName)
        .filter(this.distinctValues);

      this.customGroups = [];
      this.customGroups.push({ id: -1, name: this.$t("captureMR.None") });
      for (var i = 0; i < tabs.length; i++) {
        this.customGroups.push({ id: i, name: tabs[i] });
      }

      this.customGroups = this.customGroups.filter(this.distinctValues);

      if (this.customFields.length > 0) {
        var fLookups = this.customFields.filter(
          (t) => t.type == CustomFieldType.kLookup
        );

        fLookups.forEach((lookup) => {
          this.getCustomFieldLookupValues(lookup.typeId).then((res) => {
            let temp = res.filter((r) => r.itemId == lookup.dataId)[0];

            for (let i = 0; i < this.customFields.length; i++) {
              if (this.customFields[i].customFieldId == lookup.customFieldId) {
                this.customFields[i]["displayObj"] = temp ? temp : {};
                this.$forceUpdate();
                break;
              }
            }
          });
        });

        var fLibraries = this.customFields.filter(
          (t) => t.type == CustomFieldType.kLibrary
        );

        fLibraries.forEach(async (library) => {
          this.getCustomFieldLibraryValues(library.typeId).then((res) => {
            let temp = res.filter((r) => r.itemId == library.dataId)[0];

            for (let i = 0; i < this.customFields.length; i++) {
              if (this.customFields[i].customFieldId == library.customFieldId) {
                this.customFields[i]["displayObj"] = temp ? temp : {};
                this.$forceUpdate();
                break;
              }
            }
          });
        });

        for (var i = 0; i < this.customFields.length; i++) {
          if (
            this.customFields[i].typeId == 3 &&
            new Date(this.customFields[i].dateValue).getFullYear() <= 1900
          )
            this.customFields[i].dateValue = moment().format();
          else if (
            this.customFields[i].typeId == 6 &&
            new Date(this.customFields[i].dateTimeValue).getFullYear() <= 1900
          )
            this.customFields[i].dateTimeValue = moment().format();

          if (this.customFields[i].typeId == 3) {
            this.customFields[i].dateValue = this.alignDatesWithUts(
              this.customFields[i].dateValue
            );
            this.customFields[i].dateValueDisplay = moment(
              this.customFields[i].dateValue
            ).format("DD-MM-YYYY");
          }

          if (this.customFields[i].typeId == 6) {
            this.customFields[i].dateTimeValue = moment(
              this.customFields[i].dateTimeValue
            ).format();
            this.customFields[i].dateTimeValueDisplay = moment(
              this.customFields[i].dateTimeValue
            ).format("DD-MM-YYYY HH:mm");
          }

          if (
            this.customFields[i].isReadOnly &&
            this.customFields[i].isMandatory
          )
            this.customFields[i].isReadOnly = false;
        }
      }

      this.periodDate = moment(this.appData.periodDate)
        .subtract(1, "days")
        .format();

      this.selectedGroupName =
        this.customGroups && this.customGroups.length > 0
          ? this.customGroups[0].id
          : "";
      if (this.selectedGroupName)
        this.selectedGroupFunc(this.selectedGroupName);
    },
    alignDatesWithUts(date) {
      let today = moment();
      let dte = moment(date);

      return today
        .set({
          year: dte.year(),
          month: dte.month(),
          date: dte.date(),
        })
        .format();
    },
    async getCustomFieldLookupValues(customFieldId) {
      if (this.$store.state.csAppsOfflineMode) {
        this.lookups[customFieldId] =
          this.$store.state.offlineApplicationsData.customFieldLookups[
            customFieldId
          ];
        return this.$store.state.offlineApplicationsData.customFieldLookups[
          customFieldId
        ];
      }

      return await axios
        .get("/CustomField/GetLookupValues?lookupId=" + customFieldId)
        .then((response) => {
          if (response.status == 200) {
            this.lookups[customFieldId] = response.data;
            this.$forceUpdate();
            return response.data;
          }
        })
        .catch((e) => {
          this.$router.push("/login");
          return null;
        });
    },
    async getCustomFieldLibraryValues(customFieldId) {
      if (this.$store.state.csAppsOfflineMode) {
        this.lookups[customFieldId] =
          this.$store.state.offlineApplicationsData.customFieldLibraries[
            customFieldId
          ];
        return this.$store.state.offlineApplicationsData.customFieldLibraries[
          customFieldId
        ];
      }

      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .get("/CustomField/GetLibraryValues?libraryId=" + customFieldId)
        .then((response) => {
          if (response.status == 200) {
            this.libraries.push(response.data);
            this.$forceUpdate();
            return response.data;
          }
        })
        .catch((e) => {
          this.$router.push("/login");
          return null;
        })
        .finally(loader.hide());
    },
    setDate(el) {
      // substract one day, cause datepicker adds one if initial value is set up (checked in sorce code)
      if (el == "periodDate") {
        this.appData.periodDate = moment(this.periodDate).format();
        this.periodDate = moment(this.periodDate).subtract(1, "days").format();
      } else if (el == "periodBegin") {
        this.appData.periodBegin = moment(this.periodBegin).format();
        this.periodBegin = moment(this.periodBegin)
          .subtract(1, "days")
          .format();
      } else if (el == "periodEnd") {
        this.appData.periodEnd = moment(this.periodEnd).format();
        this.periodEnd = moment(this.periodEnd).subtract(1, "days").format();
      }
    },
    formatDateUI(date) {
      return moment(date).add(1, "days").format(uiDateFormat);
    },
    showDatePicker(dateEl) {
      this.showDate[dateEl] = true;
      var el = this.$refs[dateEl].$el;
      if (el)
        Vue.nextTick(function () {
          el.blur();
        });
    },
    formatDateYYYYMMDD(date) {
      return moment(date, "YYYY-MM-DD"); //.format();
    },
    getValidationClass(id) {
      if (this.invalidValidationFields.filter((a) => a.id == id).length == 0)
        return "";
      else return "md-invalid";
    },
    createErrorObject(obj) {
      return {
        id: obj.customFieldId,
        message:
          obj.mandatoryMessage != null && obj.mandatoryMessage != ""
            ? obj.mandatoryMessage
            : this.$t("enquiriesCustomerDetails.error") + " " + obj.name,
        groupName: obj.groupName,
      };
    },
    validateFields() {
      this.invalidValidationFields = [];

      for (var i = 0; i < this.allFields.length; i++) {
        if (this.allFields[i].isMandatory) {
          if (this.allFields[i].type == 0) {
            if (this.allFields[i].strValue == "")
              this.invalidValidationFields.push(
                this.createErrorObject(this.allFields[i])
              );
          } else if (this.allFields[i].type == 1) {
            if (
              this.allFields[i].intValue == "" ||
              this.allFields[i].intValue == null
            )
              this.invalidValidationFields.push(
                this.createErrorObject(this.allFields[i])
              );
          } else if (this.allFields[i].type == 2) {
            if (
              this.allFields[i].dblValue == "" ||
              this.allFields[i].dblValue == null
            )
              this.invalidValidationFields.push(
                this.createErrorObject(this.allFields[i])
              );
          } else if (
            this.allFields[i].type == 4 ||
            this.allFields[i].type == 5
          ) {
            if (
              this.allFields[i].dataId == "" ||
              this.allFields[i].dataId == null ||
              this.allFields[i].dataId == 0
            )
              //|| this.allFields[i].dataId < this.lookups[this.allFields[i].typeId][1].itemId
              this.invalidValidationFields.push(
                this.createErrorObject(this.allFields[i])
              );
          }
        }
      }

      this.invalidValidationFields.forEach((p) => {
        this.$alertMsg(p.message);
      });

      if (
        this.invalidValidationFields != null &&
        this.invalidValidationFields.length > 0
      ) {
        this.scrollToElement("customFields");
        let selGrpId = this.customGroups.filter(
          (c) => c.name == this.invalidValidationFields[0].groupName
        );
        this.selectedGroupName = selGrpId[0].id;
        this.selectedGroupFunc(this.selectedGroupName);
        return false;
      } else return true;
    },
    scrollToElement(refName) {
      var element = this.$refs[refName];

      element.scrollIntoView({ behavior: "smooth" });
    },
  },
};
